var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-success btn-block btn-lg btn-inschrijven",attrs:{"href":"#"},on:{"click":_vm.gotoLogin}},[_c('div',[_vm._v(_vm._s(_vm.$t('aanmelding.Inschrijven')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }